/**
 * @enum OpenFlags
 * Enumerates opened and closed states.
 */
export enum OpenFlags {
    Open = 1 << 0,
    Closed = 1 << 1,
    Transitioning = 1 << 2,
    Opening = OpenFlags.Open | OpenFlags.Transitioning,
    Closing = OpenFlags.Closed | OpenFlags.Transitioning
}
